"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { PERSONAL_PROFILE_PATH } from "@/config/modules";
import { SHOULD_BYPASS_LOGIN, useAuth } from "@/core/auth/AuthContext";
import { canAccessWebApp, getWebHomePath } from "@/core/auth/web-access";

export default function HomeRedirect() {
  const router = useRouter();
  const { user, hydrated } = useAuth();

  useEffect(() => {
    if (!hydrated) return;

    if (user) {
      router.replace(
        !canAccessWebApp(user)
          ? "/login?reason=forbidden"
          : user.profileCompletionRequired === true
            ? PERSONAL_PROFILE_PATH
            : getWebHomePath(user)
      );
      return;
    }

    router.replace(SHOULD_BYPASS_LOGIN ? getWebHomePath() : "/login");
  }, [hydrated, router, user]);

  return null;
}
